(function () {
  'use strict';

  const COLLAPSED_HEIGHT = 400;
  const TRANSITION_MS = 450;

  class ProductInfoLayout4 {
    constructor(root) {
      this.root = root;
      this.panels = Array.from(root.querySelectorAll('[data-product-info-panel]'));
    }

    getParts(panel) {
      return {
        viewport: panel.querySelector('[data-product-info-viewport]'),
        content: panel.querySelector('[data-product-info-content]'),
        toggle: panel.querySelector('[data-product-info-toggle]'),
        fade: panel.querySelector('[data-product-info-fade]'),
      };
    }

    getContentHeight(panel) {
      const { content } = this.getParts(panel);
      if (!content) return 0;
      return Math.ceil(content.getBoundingClientRect().height);
    }

    preparePanel(panel) {
      const parts = this.getParts(panel);
      if (!parts.viewport || !parts.toggle) return;

      const contentHeight = this.getContentHeight(panel);
      const needsToggle = contentHeight > COLLAPSED_HEIGHT;

      panel.classList.toggle('is-truncated-hidden', !needsToggle);

      if (!needsToggle) {
        panel.classList.remove('is-expanded');
        parts.viewport.style.maxHeight = 'none';
        parts.toggle.classList.add('is-hidden');
        parts.toggle.setAttribute('aria-expanded', 'false');
        parts.toggle.textContent =
          parts.toggle.getAttribute('data-label-collapsed') || 'View more Detail';
        return;
      }

      parts.toggle.classList.remove('is-hidden');
      parts.viewport.style.maxHeight = `${COLLAPSED_HEIGHT}px`;
      panel.classList.remove('is-expanded');
      parts.toggle.setAttribute('aria-expanded', 'false');
      parts.toggle.textContent =
        parts.toggle.getAttribute('data-label-collapsed') || 'View more Detail';
    }

    setExpandedHeight(panel) {
      const parts = this.getParts(panel);
      if (!parts.viewport || !parts.content) return;

      parts.viewport.style.maxHeight = `${this.getContentHeight(panel)}px`;
    }

    expand(panel) {
      const parts = this.getParts(panel);

      panel.classList.add('is-expanded');
      parts.viewport.style.maxHeight = `${this.getContentHeight(panel)}px`;
      parts.toggle.setAttribute('aria-expanded', 'true');
      parts.toggle.textContent =
        parts.toggle.getAttribute('data-label-expanded') || 'Show less';

      window.setTimeout(() => {
        if (panel.classList.contains('is-expanded')) {
          parts.viewport.style.maxHeight = 'none';
        }
      }, TRANSITION_MS);
    }

    collapse(panel) {
      const parts = this.getParts(panel);
      if (!parts.viewport) return;

      if (panel.classList.contains('is-expanded')) {
        parts.viewport.style.maxHeight = `${this.getContentHeight(panel)}px`;
        parts.viewport.offsetHeight;
      }

      panel.classList.remove('is-expanded');
      parts.viewport.style.maxHeight = `${COLLAPSED_HEIGHT}px`;

      if (parts.toggle) {
        parts.toggle.setAttribute('aria-expanded', 'false');
        parts.toggle.textContent =
          parts.toggle.getAttribute('data-label-collapsed') || 'View more Detail';
      }
    }

    handleToggle(panel) {
      if (panel.classList.contains('is-expanded')) {
        this.collapse(panel);
      } else {
        this.expand(panel);
      }
    }

    bindToggle(panel) {
      const parts = this.getParts(panel);

      if (!parts.toggle || parts.toggle.dataset.bound === 'true') return;

      parts.toggle.dataset.bound = 'true';
      parts.toggle.addEventListener('click', () => {
        this.handleToggle(panel);
      });
    }

    mount() {
      this.panels.forEach((panel) => {
        this.bindToggle(panel);
        this.preparePanel(panel);
      });
    }
  }

  function refreshProductInfoLayout4(root) {
    const instance = new ProductInfoLayout4(root);
    instance.mount();
    root._productInfoLayout4 = instance;
  }

  function handleLayout4Resize() {
    document.querySelectorAll('[data-product-info-layout-4]').forEach((root) => {
      const instance = root._productInfoLayout4;
      if (!instance) return;

      instance.panels.forEach((panel) => {
        if (panel.classList.contains('is-expanded')) {
          instance.setExpandedHeight(panel);
        } else {
          instance.preparePanel(panel);
        }
      });
    });
  }

  let resizeTimer;

  function initProductInfoLayout4() {
    document.querySelectorAll('[data-product-info-layout-4]').forEach((root) => {
      refreshProductInfoLayout4(root);
    });
  }

  if (!window.__productInfoLayout4ResizeBound) {
    window.__productInfoLayout4ResizeBound = true;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(handleLayout4Resize, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductInfoLayout4);
  } else {
    initProductInfoLayout4();
  }

  document.addEventListener('shopify:section:load', initProductInfoLayout4);
})();
